var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 283,
    height: 35,
    viewBox: "0 0 283 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M200.093 0H195.511V35H200.093V0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0081 4.57566H35.2247L39.2259 0H67.0093L63.0081 4.57566Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4091 19.7898H35.2247L39.2259 15.2141H55.4065L51.4091 19.7898Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0081 35H35.2247L39.2259 30.4243H67.0093L63.0081 35Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M143.147 4.57566H115.368L119.369 0H147.149L143.147 4.57566Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M131.548 19.7898H115.368L119.369 15.2141H135.55L131.548 19.7898Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M143.147 35H115.368L119.369 30.4243H147.149L143.147 35Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M87.6379 35L72.9768 0H77.9402L89.188 26.8515L89.2338 26.9545L92.6012 35H87.6379Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M93.9108 27.4349L105.399 0H100.436L91.4635 21.4255L93.9108 27.4349Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M283 0L257.66 24.8535V35H253.079V0H257.66V18.4399L276.46 0H283Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M282.897 35H276.838L265.506 21.9212L268.969 18.928L282.897 35Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5653 35H0V30.4243H11.6677L19.2502 22.8554V12.1484L11.6677 4.57566H0V0H13.5653L23.8318 10.2533V24.7505L13.5653 35Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M239.765 35H226.2L215.933 24.7505V10.2533L226.2 0H239.765V4.57566H228.097L220.515 12.1484V22.8554L228.097 30.4243H239.765V35Z",
    fill: "white"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M174.119 23.252L180.919 16.4571V6.79486L174.119 0H156.896V4.57566H172.221L176.337 8.68994V14.562L172.221 18.6763H156.896V35H161.478V23.252H165.887L175.062 35H180.85L171.679 23.252H174.119Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.cb8cd921b2e48d6a4852516bf8451354.svg";
export { ForwardRef as ReactComponent };